<script>
import api from '@/helpers/api'
import tableMixin from '@/mixins/table'

import {
  required,
  requiredIf,
  integer,
  minValue,
  maxValue,
  minLength
} from 'vuelidate/lib/validators'

export default {
  name: 'parts',
  props: {
    value: { type: Object, default: () => {} }
  },
  mixins: [tableMixin],
  data: vm => ({
    isLoading: false,
    search: '',
    form: {
      specs: {
        parts: []
      },
      ...vm.value
    },
    fields: [
      {
        key: 'item',
        label: 'Item'
      },
      {
        key: 'qty',
        label: 'Qty.',
        thStyle: { width: '100px', textAlign: 'center' }
      }
    ]
  }),
  watch: {
    search: 'onRefresh',
    currentPage: 'onRefresh',
    perPage: 'onRefresh'
  },
  computed: {},
  validations: {
    form: {
      specs: {
        parts: {
          required
        }
      }
    }
  },
  methods: {
    validate () {
      if (!this.$v && !this.$v.form) return true
      this.$v.form.$touch()
      if (!this.$v.form.$invalid) {
        this.$emit('validated', { ...this.form })
        this.$emit('input', { ...this.form })
      }

      return !this.$v.form.$invalid
    },
    async onRefresh () {
      this.isLoading = true
      let filters = [
        { is_discontinued: { _eq: false } },
        { is_sales_item: { _eq: true } },
        { is_webshop_item: { _eq: false } }
        //{ form_data: { _contains: { model_type: this.form.specs.model_type } } }
      ]

      let { items, total_rows } = await api.items.fetchPage({
        page: this.currentPage,
        pageSize: this.perPage === 'All' ? -1 : this.perPage,
        filters,
        needle: this.search,
        orderBy: { rating: 'desc', short_description: 'asc' }
      })

      this.data = items.map(i => {
        return { ...i, qty: 0 }
      })
      this.totalRows = total_rows
      this.isLoading = false
    }
  }
}
</script>
<template>
  <div>
    <b-row no-gutters align-h="end" align-v="center" class="mb-2">
      <g-search-input
        v-model="search"
        placeholder="Find Items"
        width="300px"
        class="mr-0 ml-2"
      />
    </b-row>

    <b-table
      show-empty
      hover
      striped
      align-middle
      :items="data"
      class="table-sm mt-2 hidden-scrollbar"
      :fields="fields"
      :busy="isLoading"
      head-variant="light"
      tbody-tr-class="pointer"
      no-border-collapse
      sticky-header="300px"
    >
      <template v-slot:cell(item)="{ item }">
        <div class="d-flex flex-column">
          <span class="font-weight-bold text-muted">{{ item.code }}</span>
          <small class="font-size-sm text-muted">{{
            item.short_description
          }}</small>
        </div>
      </template>

      <template v-slot:cell(qty)="{ item }">
        <div class="d-flex justify-content-center">
          <b-form-input
            v-model.number="item.qty"
            class="text-center m-0"
            v-on:focus="$event.target.select()"
            v-on:change="onQuantityUpdated(item)"
            size="sm"
            style="max-width: 50px"
          />
        </div>
      </template>
    </b-table>
  </div>
</template>
